import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeGroupReferenceService extends BaseReferenceService {
  constructor() {
    super('ProductTypeGroupReference');
  }
  getForCustomerOrder(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/CustomerOrder`);
  }
}
